// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";

const metadata: BuiltInScriptMetadata = {
  name: "Grapple Tangle",
  id: "grapple-tangle",
  metadata: {
    imports: ["grapple", "aim", "wait", "self", "getEntities"],
    icon: {
      backgroundColor: 2168645,
      layers: [
        {
          iconKey: "grapple",
          position: {
            x: 0,
            y: 0
          },
          scale: 0.95,
          rotation: 9,
          color: 16538594
        },
        {
          iconKey: "aim",
          position: {
            x: 15,
            y: 3
          },
          scale: 0.59,
          rotation: 18,
          color: 15400703
        },
        {
          iconKey: "delay",
          position: {
            x: -16,
            y: 0
          },
          scale: 0.58,
          rotation: 11,
          color: 16773616
        }
      ]
    }
  }
};

export default metadata;
